<template>
<div class="chapter">
<div class="inner_page">
<h1 class="heading"><span class="smallcaps">ALSO BY</span><span class="smallcaps"> <br/></span>A<span class="smallcaps">MÉLIE </span>N<span class="smallcaps">OTHOMB</span></h1>
<p class="center"><em class="italic">Tokyo Fiancée</em></p>
<p class="center"><em class="italic">Hygiene and the Assassin</em></p>
<p class="center"><em class="italic">Life Form</em></p>
<p class="center"><em class="italic">Pétronille</em></p>
<p class="center"><em class="italic">Strike Your Heart</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// thirst_00000.vue?5d739d24